/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstallProgramGroupRequest
 */
export interface InstallProgramGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof InstallProgramGroupRequest
     */
    programGroupId: string;
}

/**
 * Check if a given object implements the InstallProgramGroupRequest interface.
 */
export function instanceOfInstallProgramGroupRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "programGroupId" in value;

    return isInstance;
}

export function InstallProgramGroupRequestFromJSON(json: any): InstallProgramGroupRequest {
    return InstallProgramGroupRequestFromJSONTyped(json, false);
}

export function InstallProgramGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallProgramGroupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programGroupId': json['programGroupId'],
    };
}

export function InstallProgramGroupRequestToJSON(value?: InstallProgramGroupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programGroupId': value.programGroupId,
    };
}

